// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + "ae311e12d6b4f6d6e29d" + ".chunk.js";
};